<template>
  <div>

    <!-- ── Stat Tiles ──────────────────────────────────────────── -->
    <div class="row mb-2">

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-user-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Civil Servants</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.state_civil | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-info rounded-circle text-info">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents (C. Servants)</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_dynamic | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-success rounded-circle text-success">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Pensioners</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.pensioners | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Political Appointees</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.public_servant | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-danger rounded-circle text-danger">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents (Appointees)</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_public_servants | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">T-SHIP</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.t_ship | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">LGA Civil Servant</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.lga_civil }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents (LGA CS)</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_lga_civil_servants | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100" style="border-left: 3px solid #2563eb !important;">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Formal Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-primary">{{ formaldata.enrollees | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

    </div>

    <!-- ── Enrollee Distribution by LGA & Facility ──────────────── -->
    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-map-pin text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by LGA and Facility</h6>
      </div>
      <div class="card-body pt-0">
        <EnrolleebyLGAandFacility />
      </div>
    </div>

    <div class="mb-4">
      <FormalSectorChartByLGA />
    </div>

    <div class="mb-4">
      <DependentsByLGAChart />
    </div>

    <!-- ── Gender Distribution by LGA ────────────────────────────── -->
    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-bar-chart-2 text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Gender Distribution by LGA</h6>
      </div>
      <div class="card-body pt-0">
        <GenderbyLGA :sectors="sectors" />
      </div>
    </div>

    <div class="mb-4">
      <MDAData />
    </div>

    <div class="mb-4">
      <gender-category-formal></gender-category-formal>
    </div>

  </div>
</template>

<script>
// import MDAData from "./mda";
import FormalSectorChartByLGA from "./FormalSectorChartByLGA";
import GenderbyLGA from "./GenderbyLGA";
import DependentsByLGAChart from "./DependentsByLGAChart";
// import GenderCategoryFormal from "./GenderCategoryFormal.vue";
import EnrolleebyLGAandFacility from "./EnrolleebyLGAandFacility";


export default {
  components: {
    GenderbyLGA,
    FormalSectorChartByLGA,
    // MDAData,
    DependentsByLGAChart,
    EnrolleebyLGAandFacility,
  },

  data() {
    return {
      agency: "",
      user: null,
      mydata: "",
      formaldata: "",
      total: 0,
      auth_user: "",
      providers: "",
      clients: "",
      total_clients: "",
      sectors: [
        {
          name: "State Civil Servant",
        },
        {
          name: "State Public Servant",
        },
      ],
      claims: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
    };
  },
  beforeMount() {
    this.axios
      .get(`/api/v1/auth/getformalsectorenrollees`)
      .then((response) => {
        this.formaldata = response.data;

      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
  //
  },

  methods: {},
  created() {},
};
</script>
